import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Akebono 100 Discoveries</h1>
        <p>Googleにはない、あなただけの出会いを。</p>
        <button>スポットを探す</button>
      </header>
    </div>
  );
}

export default App;
